import {Component, ElementRef, ViewChild, Renderer2, TemplateRef, AfterViewInit, isDevMode} from '@angular/core'
import {FormBuilder, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import App from "../../../helpers/app";
import {AuthenticationService} from "../../../_helpers/authentication.service";
import {ServidorService} from "../../../_helpers/servidor.service";
import * as cep from 'cep-promise'
import {UploadFile, NzModalService, NzModalRef} from "ng-zorro-antd";
import * as moment from 'moment'
import { saveAs } from "file-saver";
import swal from "sweetalert2";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Api from 'src/app/_helpers/api';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var faceapi: any;
declare var Calendly: any;


@Component({
    templateUrl: './default-dashboard.component.html',
    styleUrls: ['./default-dashboard.component.css']
})

export class DefaultDashboardComponent implements AfterViewInit {
  isDevMode: boolean = isDevMode();
  @ViewChild('calendlycontainer', { static: true }) calendlycontainer: ElementRef;

  swicthStepCurrent = 0;
  isCameraOpened = false
  adicionandoDependente = false
  editandoDependente = false
  loadingCidades = false
  drawCanvas = false
  loadingAll= false
  loadingCidadesDependente = false
  titleStep = '';
  isCadastrado = false
  idCadastro = null
  radioVerticalValue = '';
  style = {
    display   : 'block',
    height    : '30px',
    lineHeight: '30px'
  };

  // @ts-ignore
  @ViewChild('video') videoElement: ElementRef;
  // @ts-ignore
  @ViewChild('canvas') canvas: ElementRef;

  constraints = {
    video: {
      facingMode: "environment",
      width: { ideal: 4096 },
      height: { ideal: 2160 }
    }
  };
  videoWidth = 0;
  videoHeight = 0;
  estadosCivis = [];
  escolaridades = [];
  todosDependentes = [];
  anexos = [];

  tiposConta = [
    {id: '1', descricao: 'Conta Corrente'},
    {id: '2', descricao: 'Poupança'},
    {id: '3', descricao: 'Cartão Salário'},

  ];

  carreiras = [
    {
      id: 1,
      name: "Aposentadoria",
    },
    {
      id: 2,
      name: "Pensão",
    },
    {
      id: 3,
      name: "Professor",
    },
    {
      id: 4,
      name: "Auxílio Doença",
    },
    {
      id: 5,
      name: "Outros",
    },
  ];
  carreirasAtivo = [
    {
      id: 6,
      name: "Professor",
    },
    {
      id: 7,
      name: "Especial (Agentes Nocivos)",
    },
    {
      id: 8,
      name: "Outros Cargos",
    },
    {
      id: 21,
      name: "Militares",
    }
  ];
  carreirasAposentado = [
    { name: 'Aposentadoria por Idade', id: 9},
    { name: 'Aposentadoria por Tempo de Contribuição', id: 10},
    { name: 'Aposentadoria Compulsória', id: 11},
    { name: 'Aposentadoria por Invalidez', id: 12},
    { name: 'Aposentadoria como Professor', id: 13},
    { name: 'Aposentadoria Especial - atividade de risco (Art. 40, § 4o, inc. II, CF)', id: 14},
    { name: 'Aposentadoria Especial - atividade prejudiciais à saúde ou integridade física (Art. 40, § 4o, inc. III, CF)', id: 15},
    { name: 'Militares Inativos - Reserva Remunerada', id: 16},
    { name: 'Militares Inativos - Reforma', id: 17}
  ];
  carreirasPensionista = [
    {
      id: 18,
      name: "Vitalícia",
    },
    {
      id: 19,
      name: "Temporária",
    }
  ];
  carreirasExonerado = [
    {
      id: 20,
      name: "Exonerado",
    }
  ];

  bancos = [
    {id: '1', descricao: '000 - Banco Bankpar S.A.'},
    {id: '2', descricao: '001 - Banco do Brasil S.A.'},
    {id: '3', descricao: '003 - Banco da Amazônia S.A.'},
    {id: '4', descricao: '004 - Banco do Nordeste do Brasil S.A.'},
    {id: '5', descricao: '012 - Banco Standard de Investimentos S.A.'},
    {id: '6', descricao: '014 - Natixis Brasil S.A. Banco Múltiplo'},
    {id: '7', descricao: '019 - Banco Azteca do Brasil S.A.'},
    {id: '8', descricao: '021 - BANESTES S.A. Banco do Estado do Espírito Santo'},
    {id: '9', descricao: '024 - Banco de Pernambuco S.A. - BANDEPE'},
    {id: '10', descricao: '025 - Banco Alfa S.A.'},
    {id: '11', descricao: '029 - Banco Banerj S.A.'},
    {id: '12', descricao: '031 - Banco Beg S.A.'},
    {id: '13', descricao: '033 - Banco Santander (Brasil) S.A.'},
    {id: '14', descricao: '036 - Banco Bradesco BBI S.A.'},
    {id: '15', descricao: '037 - Banco do Estado do Pará S.A.'},
    {id: '16', descricao: '039 - Banco do Estado do Piauí S.A. - BEP'},
    {id: '17', descricao: '040 - Banco Cargill S.A.'},
    {id: '18', descricao: '041 - Banco do Estado do Rio Grande do Sul S.A.'},
    {id: '19', descricao: '044 - Banco BVA S.A.'},
    {id: '20', descricao: '045 - Banco Opportunity S.A.'},
    {id: '21', descricao: '047 - Banco do Estado de Sergipe S.A.'},
    {id: '22', descricao: '062 - Hipercard Banco Múltiplo S.A.'},
    {id: '23', descricao: '063 - Banco Ibi S.A. Banco Múltiplo'},
    {id: '24', descricao: '064 - Goldman Sachs do Brasil Banco Múltiplo S.A.'},
    {id: '25', descricao: '065 - Banco Bracce S.A.'},
    {id: '26', descricao: '066 - Banco Morgan Stanley S.A.'},
    {id: '27', descricao: '069 - BPN Brasil Banco Múltiplo S.A.'},
    {id: '28', descricao: '070 - BRB - Banco de Brasília S.A.'},
    {id: '29', descricao: '072 - Banco Rural Mais S.A.'},
    {id: '30', descricao: '073 - BB Banco Popular do Brasil S.A.'},
    {id: '31', descricao: '074 - Banco J. Safra S.A.'},
    {id: '32', descricao: '075 - Banco CR2 S.A.'},
    {id: '33', descricao: '076 - Banco KDB S.A.'},
    {id: '34', descricao: '078 - BES Investimento do Brasil S.A.-Banco de Investimento'},
    {id: '35', descricao: '079 - JBS Banco S.A.'},
    {id: '36', descricao: '084 - Unicred Norte do Paraná'},
    {id: '37', descricao: '096 - Banco BM&amp;F de Serviços de Liquidação e Custódia S.A'},
    {id: '38', descricao: '104 - Caixa Econômica Federal'},
    {id: '39', descricao: '107 - Banco BBM S.A.'},
    {id: '40', descricao: '168 - HSBC Finance (Brasil) S.A. - Banco Múltiplo'},
    {id: '41', descricao: '184 - Banco Itaú BBA S.A.'},
    {id: '42', descricao: '204 - Banco Bradesco Cartões S.A.'},
    {id: '43', descricao: '208 - Banco BTG Pactual S.A.'},
    {id: '44', descricao: '212 - Banco Matone S.A.'},
    {id: '45', descricao: '213 - Banco Arbi S.A.'},
    {id: '46', descricao: '214 - Banco Dibens S.A.'},
    {id: '47', descricao: '215 - Banco Comercial e de Investimento Sudameris S.A.'},
    {id: '48', descricao: '217 - Banco John Deere S.A.'},
    {id: '49', descricao: '218 - Banco Bonsucesso S.A.'},
    {id: '50', descricao: '222 - Banco Credit Agricole Brasil S.A.'},
    {id: '51', descricao: '224 - Banco Fibra S.A.'},
    {id: '52', descricao: '225 - Banco Brascan S.A.'},
    {id: '53', descricao: '229 - Banco Cruzeiro do Sul S.A.'},
    {id: '54', descricao: '230 - Unicard Banco Múltiplo S.A.'},
    {id: '55', descricao: '233 - Banco GE Capital S.A.'},
    {id: '56', descricao: '237 - Banco Bradesco S.A.'},
    {id: '57', descricao: '241 - Banco Clássico S.A.'},
    {id: '58', descricao: '243 - Banco Máxima S.A.'},
    {id: '59', descricao: '246 - Banco ABC Brasil S.A.'},
    {id: '60', descricao: '248 - Banco Boavista Interatlântico S.A.'},
    {id: '61', descricao: '249 - Banco Investcred Unibanco S.A.'},
    {id: '62', descricao: '250 - Banco Schahin S.A.'},
    {id: '63', descricao: '254 - Paraná Banco S.A.'},
    {id: '64', descricao: '263 - Banco Cacique S.A.'},
    {id: '65', descricao: '265 - Banco Fator S.A.'},
    {id: '66', descricao: '266 - Banco Cédula S.A.'},
    {id: '67', descricao: '300 - Banco de La Nacion Argentina'},
    {id: '68', descricao: '318 - Banco BMG S.A.'},
    {id: '69', descricao: '320 - Banco Industrial e Comercial S.A.'},
    {id: '70', descricao: '341 - Itaú Unibanco S.A.'},
    {id: '71', descricao: '356 - Banco Real S.A.'},
    {id: '72', descricao: '366 - Banco Société Générale Brasil S.A.'},
    {id: '73', descricao: '370 - Banco WestLB do Brasil S.A.'},
    {id: '74', descricao: '376 - Banco J. P. Morgan S.A.'},
    {id: '75', descricao: '389 - Banco Mercantil do Brasil S.A.'},
    {id: '76', descricao: '394 - Banco Bradesco Financiamentos S.A.'},
    {id: '77', descricao: '399 - HSBC Bank Brasil S.A. - Banco Múltiplo'},
    {id: '78', descricao: '409 - UNIBANCO - União de Bancos Brasileiros S.A.'},
    {id: '79', descricao: '412 - Banco Capital S.A.'},
    {id: '80', descricao: '422 - Banco Safra S.A.'},
    {id: '81', descricao: '453 - Banco Rural S.A.'},
    {id: '82', descricao: '456 - Banco de Tokyo-Mitsubishi UFJ Brasil S.A.'},
    {id: '83', descricao: '464 - Banco Sumitomo Mitsui Brasileiro S.A.'},
    {id: '84', descricao: '473 - Banco Caixa Geral - Brasil S.A.'},
    {id: '85', descricao: '477 - Citibank N.A.'},
    {id: '86', descricao: '479 - Banco ItaúBank S.A'},
    {id: '87', descricao: '487 - Deutsche Bank S.A. - Banco Alemão'},
    {id: '88', descricao: '488 - JPMorgan Chase Bank'},
    {id: '89', descricao: '492 - ING Bank N.V.'},
    {id: '90', descricao: '494 - Banco de La Republica Oriental del Uruguay'},
    {id: '91', descricao: '495 - Banco de La Provincia de Buenos Aires'},
    {id: '92', descricao: '505 - Banco Credit Suisse (Brasil) S.A.'},
    {id: '93', descricao: '600 - Banco Luso Brasileiro S.A.'},
    {id: '94', descricao: '604 - Banco Industrial do Brasil S.A.'},
    {id: '95', descricao: '610 - Banco VR S.A.'},
    {id: '96', descricao: '611 - Banco Paulista S.A.'},
    {id: '97', descricao: '612 - Banco Guanabara S.A.'},
    {id: '98', descricao: '613 - Banco Pecúnia S.A.'},
    {id: '99', descricao: '623 - Banco Panamericano S.A.'},
    {id: '100', descricao: '626 - Banco Ficsa S.A.'},
    {id: '101', descricao: '630 - Banco Intercap S.A.'},
    {id: '102', descricao: '633 - Banco Rendimento S.A.'},
    {id: '103', descricao: '634 - Banco Triângulo S.A.'},
    {id: '104', descricao: '637 - Banco Sofisa S.A.'},
    {id: '105', descricao: '638 - Banco Prosper S.A.'},
    {id: '106', descricao: '641 - Banco Alvorada S.A.'},
    {id: '107', descricao: '643 - Banco Pine S.A.'},
    {id: '108', descricao: '652 - Itaú Unibanco Holding S.A.'},
    {id: '109', descricao: '653 - Banco Indusval S.A.'},
    {id: '110', descricao: '654 - Banco A.J.Renner S.A.'},
    {id: '111', descricao: '655 - Banco Votorantim S.A.'},
    {id: '112', descricao: '707 - Banco Daycoval S.A.'},
    {id: '113', descricao: '719 - Banif-Banco Internacional do Funchal (Brasil)S.A.'},
    {id: '114', descricao: '721 - Banco Credibel S.A.'},
    {id: '115', descricao: '724 - Banco Porto Seguro S.A.'},
    {id: '116', descricao: '734 - Banco Gerdau S.A.'},
    {id: '117', descricao: '735 - Banco Pottencial S.A.'},
    {id: '118', descricao: '738 - Banco Morada S.A.'},
    {id: '119', descricao: '739 - Banco BGN S.A.'},
    {id: '120', descricao: '740 - Banco Barclays S.A.'},
    {id: '121', descricao: '741 - Banco Ribeirão Preto S.A.'},
    {id: '122', descricao: '743 - Banco Semear S.A.'},
    {id: '123', descricao: '744 - BankBoston N.A.'},
    {id: '124', descricao: '745 - Banco Citibank S.A.'},
    {id: '125', descricao: '746 - Banco Modal S.A.'},
    {id: '126', descricao: '747 - Banco Rabobank International Brasil S.A.'},
    {id: '127', descricao: '748 - Banco Cooperativo Sicredi S.A.'},
    {id: '128', descricao: '749 - Banco Simples S.A.'},
    {id: '129', descricao: '751 - Dresdner Bank Brasil S.A. - Banco Múltiplo'},
    {id: '130', descricao: '752 - Banco BNP Paribas Brasil S.A.'},
    {id: '131', descricao: '753 - NBC Bank Brasil S.A. - Banco Múltiplo'},
    {id: '132', descricao: '755 - Bank of America Merrill Lynch Banco Múltiplo S.A.'},
    {id: '133', descricao: '756 - Banco Cooperativo do Brasil S.A. - BANCOOB'},
    {id: '134', descricao: '757 - Banco KEB do Brasil S.A.'},
    {id: '135', descricao: '077-9 - Banco Intermedium S.A.'},
    {id: '136', descricao: '081-7 - Concórdia Banco S.A.'},
    {id: '137', descricao: '082-5 - Banco Topázio S.A.'},
    {id: '138', descricao: '083-3 - Banco da China Brasil S.A.'},
    {id: '139', descricao: '085-x - Cooperativa Central de Crédito Urbano-CECRED'},
    {id: '140', descricao: '086-8 - OBOE Crédito Financiamento e Investimento S.A.'},
    {id: '141', descricao: '087-6 - Cooperativa Unicred Central Santa Catarina'},
    {id: '142', descricao: '088-4 - Banco Randon S.A.'},
    {id: '143', descricao: '089-2 - Cooperativa de Crédito Rural da Região de Mogiana'},
    {id: '144', descricao: '090-2 - Cooperativa Central de Economia e Crédito Mutuo das Unicreds'},
    {id: '145', descricao: '091-4 - Unicred Central do Rio Grande do Sul'},
    {id: '146', descricao: '092-2 - Brickell S.A. Crédito, financiamento e Investimento'},
    {id: '147', descricao: '094-2 - Banco Petra S.A.'},
    {id: '148', descricao: '097-3 - Cooperativa Central de Crédito Noroeste Brasileiro Ltda.'},
    {id: '149', descricao: '098-1 - Credicorol Cooperativa de Crédito Rural'},
    {id: '150', descricao: '099-x - Cooperativa Central de Economia e Credito Mutuo das Unicreds'},
    {id: '151', descricao: 'M03 - Banco Fiat S.A.'},
    {id: '152', descricao: 'M06 - Banco de Lage Landen Brasil S.A.'},
    {id: '153', descricao: 'M07 - Banco GMAC S.A.'},
    {id: '154', descricao: 'M08 - Banco Citicard S.A.'},
    {id: '155', descricao: 'M09 - Banco Itaucred Financiamentos S.A.'},
    {id: '156', descricao: 'M10 - Banco Moneo S.A.'},
    {id: '157', descricao: 'M11 - Banco IBM S.A.'},
    {id: '158', descricao: 'M12 - Banco Maxinvest S.A.'},
    {id: '159', descricao: 'M13 - Banco Tricury S.A.'},
    {id: '160', descricao: 'M14 - Banco Volkswagen S.A.'},
    {id: '161', descricao: 'M15 - Banco BRJ S.A.'},
    {id: '162', descricao: 'M16 - Banco Rodobens S.A.'},
    {id: '163', descricao: 'M17 - Banco Ourinvest S.A.'},
    {id: '164', descricao: 'M18 - Banco Ford S.A.'},
    {id: '165', descricao: 'M19 - Banco CNH Capital S.A.'},
    {id: '166', descricao: 'M20 - Banco Toyota do Brasil S.A.'},
    {id: '167', descricao: 'M21 - Banco Daimlerchrysler S.A.'},
    {id: '168', descricao: 'M22 - Banco Honda S.A.'},
    {id: '169', descricao: 'M23 - Banco Volvo (Brasil) S.A.'},
    {id: '170', descricao: 'M24 - Banco PSA Finance Brasil S.A.'},
    {id: '171', descricao: '001 - Outros'},
    {id: '172', descricao: 'O01 - Outros'},
    {id: '173', descricao: 'O01 - Outros'},
    {id: '174', descricao: 'O01 - Outros'},
    {id: '175', descricao: 'O01 - Outros'},
    {id: '171', descricao: 'O01 - Outros'},
    {id: '172', descricao: '121 - Banco Agibank S.A.'},
    {id: '173', descricao: '077 - Banco Inter S.A.'},
    {id: '174', descricao: '260 - Nu Pagamentos S.A. (Nubank)'},
    {id: '175', descricao: '212 - Banco Original S.A.'},
    {id: '176', descricao: '336 - Banco C6'},
    {id: '177', descricao: '323 - MERCADO PAGO'},
    {id: '178', descricao: '290 - PAGSEGURO'},
  ]

  estadosNaturalidade = [];
  cidadesNaturalidadeDependente = [];
  cidadesNaturalidade = [];
  cidadesEndereco = [];
  cidadesEnderecoDependente = [];
  orgaos = []
  tiposDepedencia = []
  motivosInicioDependencia = []
  orgaosMovimentos = []
  tiposLogradouro = []
  searchingCep = false
  searchingCepDependente = false
  loadingCidadeEndereco = false
  loadingCidadeEnderecoDependente = false
  dateFormat = 'dd/MM/yyyy';


  servidor = {
    id: null,
    nome: null,
    nascimento: null,
    estadoCivil: null,
    sexo: null,
    status: 0,
    estadoNaturalidade: null,
    cidadeNaturalidade: null,
    nacionalidade: 'Brasileiro',
    escolaridade: null,
    nomeMae: null,
    nomePai: null,
    dataIngresso: null,
    deficiente: null,
    agenda: "Reunião Não Agendada"
  }


  movimentos = {
    tipo_vinculo: 'Concursado',
    matricula: null,
    matricula_2: null,
    data_nomeacao: this.servidor.dataIngresso,
    data_exercicio: this.servidor.dataIngresso,
    data_posse: this.servidor.dataIngresso,
    cargo_acumulacao: null,
    data_movimentacao: this.servidor.dataIngresso,
    situacao_funcional: null,
    situacao_funcional_2: null,
    orgao: null,
    carreira: null,
    ingresso_carreira: this.servidor.dataIngresso,
    cargo: null,
    ingresso_cargo: this.servidor.dataIngresso,
    carga_horaria: null,
    local_trabalho: null,
    abono_permanencia: null,
    observacoes: null,
  }


  copiarDoServidor = false

  idNovoDependente = 0
  idNovoTempo = 0

  dependente = {
    id: null,
    nome: null,
    nascimento: null,
    estadoCivil: null,
    sexo: null,
    estadoNaturalidade: null,
    cidadeNaturalidade: null,
    nacionalidade: 'Brasileiro',
    escolaridade: null,
    nomeMae: null,
    nomePai: null,
    deficiente: null,
    tipoLogradouro: null,
    logradouro: null,
    numero: null,
    complemento: '',
    bairro: null,
    estado: null,
    cidade: null,
    cep: null,
    telefone: '',
    celular: null,
    email: null,
    tipo_dependencia: null,
    motivo_inicio: null,
  }
  todosTemposPassados = []

  tempopassado = {
    id: null,
    cnpj_cpf_empregador: null,
    nome_empregrador: null,
    data_entrada: null,
    data_fim: null,
    tempo_bruto: null,
  }
  tempototalnovo = null
  adicionandoTempo = false
  editandoTempo = false
  documento = {
    cpf: null,
    rg: null,
    dataEmissaoRg: null,
    orgaoExpedidorRg: null,
    ufRg: null,
    nit: null,
  }

  endereco = {
    tipoLogradouro: null,
    logradouro: null,
    numero: null,
    complemento: '',
    bairro: null,
    estado: null,
    cidade: null,
    cep: null,
  }

  anexosEndereco = []
  anexosDependente = []
  anexosDocumentos = []

  statuos = 0
  erruos = ''
  viewModalDocument = false
  modalDocument = null
  anexoEndereco = null
  anexoDocumentos = null
  anexoDadosBancarios = null
  anexoDependentes = null



  contatos = {
    telefone: '',
    celular: null,
    email: null,
  }
  // bancario = {
  //   banco: null,
  //   tipoConta: null,
  //   agencia: null,
  //   conta: null,
  //   digitoConta: null,
  // }

  pre(): void {

      this.swicthStepCurrent -= 10;
    this.verifyTitle()
    window.scroll(0,0);
  }

  next(): void {

    this.swicthStepCurrent += 10;
    this.verifyTitle()
    this.verifyDatasMovimentos()
    //so executar se nao tiver cadastrado
    if(!this.isCadastrado){
      this.savePartial()
    }

    window.scroll(0,0);
  }
  deletePartial() {
    const self = this
    const currentUser = self.authenticationService.currentUserValue;
    const json = JSON.parse(JSON.stringify(currentUser))
    let key = 'user'+json.user.id
    localStorage.removeItem(key);

  }

  loadPartial(){
    const self = this
    const currentUser = self.authenticationService.currentUserValue;
    const json = JSON.parse(JSON.stringify(currentUser))
    let key = 'user'+json.user.id
    let partial = JSON.parse(localStorage.getItem(key))
    if(partial){
      if(partial.swicthStepCurrent) self.swicthStepCurrent = partial.swicthStepCurrent
      if(partial.radioVerticalValue) self.radioVerticalValue = partial.radioVerticalValue
      if(partial.servidor) self.servidor = partial.servidor
      if(partial.movimentos) self.movimentos = partial.movimentos
      if(partial.documento) self.documento = partial.documento
      if(partial.endereco) self.endereco = partial.endereco
      if(partial.contatos) self.contatos = partial.contatos
      // if(partial.bancario) self.bancario = partial.bancario
      if(partial.todosDependentes) self.todosDependentes = partial.todosDependentes
      if(partial.anexosEndereco) self.anexosEndereco = partial.anexosEndereco
      if(partial.anexosDependente) self.anexosDependente = partial.anexosDependente
      if(partial.anexosDocumentos) self.anexosDocumentos = partial.anexosDocumentos
      if(partial.cidadesNaturalidade) self.cidadesNaturalidade = partial.cidadesNaturalidade
      if(partial.cidadesEndereco) self.cidadesEndereco = partial.cidadesEndereco

      if(partial.imgReferencia) self.imgReferencia = partial.imgReferencia
      if(partial.lastResult) self.lastResult = partial.lastResult
      if(partial.lastInput) self.lastInput = partial.lastInput
      if(partial.nextEnabled) self.nextEnabled = partial.nextEnabled

    }
  }

  savePartial(){
    const self = this
    const currentUser = self.authenticationService.currentUserValue;
    const json = JSON.parse(JSON.stringify(currentUser))
    let key = 'user'+json.user.id

    let partial = {
      swicthStepCurrent: this.swicthStepCurrent,
      radioVerticalValue: this.radioVerticalValue,
      imgReferencia: this.imgReferencia,
      lastResult : this.lastResult,
      lastInput : this.lastInput,
      nextEnabled : this.nextEnabled,
      servidor: self.servidor,
      movimentos: self.movimentos,
      documento: self.documento,
      endereco: self.endereco,
      contatos: self.contatos,
      // bancario: self.bancario,
      todosDependentes: self.todosDependentes,
      anexosEndereco : self.anexosEndereco,
      anexosDependente : self.anexosDependente,
      anexosDocumentos : self.anexosDocumentos,
      cidadesNaturalidade : self.cidadesNaturalidade,
      cidadesEndereco : self.cidadesEndereco
    }
    localStorage.setItem(key, JSON.stringify(partial))
  }


  verifyDatasMovimentos(){
    if(!this.movimentos.data_nomeacao) this.movimentos.data_nomeacao = this.servidor.dataIngresso
    if(!this.movimentos.data_exercicio) this.movimentos.data_exercicio = this.servidor.dataIngresso
    if(!this.movimentos.data_posse) this.movimentos.data_posse = this.servidor.dataIngresso
    if(!this.movimentos.data_movimentacao) this.movimentos.data_movimentacao = this.servidor.dataIngresso
    if(!this.movimentos.ingresso_carreira) this.movimentos.ingresso_carreira = this.servidor.dataIngresso
    if(!this.movimentos.ingresso_cargo) this.movimentos.ingresso_cargo = this.servidor.dataIngresso

    if(this.radioVerticalValue){
      if(this.radioVerticalValue == 'A'){
        this.movimentos.situacao_funcional = '1'
        this.labelMatricula1 = 'Matrícula Ativa'
      }else if(this.radioVerticalValue == 'B') {
        this.movimentos.situacao_funcional = '3'
        this.labelMatricula1 = 'Matrícula Aposentado/Inativo'
      }else if(this.radioVerticalValue == 'C') {
        this.movimentos.situacao_funcional = '1'
        this.movimentos.situacao_funcional_2 = '3'
        this.labelMatricula1 = 'Matrícula Ativa'
        this.labelMatricula2 = 'Matrícula Aposentado/Inativo'
      }else if(this.radioVerticalValue == 'D') {
        this.movimentos.situacao_funcional = '4'
        this.labelMatricula1 = 'Matrícula Pensionista'
      }else if(this.radioVerticalValue == 'E') {
        this.movimentos.situacao_funcional = '1'
        this.movimentos.situacao_funcional_2 = '4'
        this.labelMatricula1 = 'Matrícula Ativa'
        this.labelMatricula2 = 'Matrícula Pensionista'
      }else if(this.radioVerticalValue == 'F') {
        this.movimentos.situacao_funcional = '3'
        this.movimentos.situacao_funcional_2 = '4'
        this.labelMatricula1 = 'Matrícula Aposentado/Inativo'
        this.labelMatricula2 = 'Matrícula Pensionista'
      }
    }
  }

  verificaLabelsServidorCadastrado(){
    if(this.movimentos.situacao_funcional==='1'){
      this.labelMatricula1 = 'Matrícula Ativa'
    }else if(this.movimentos.situacao_funcional==='3'){
      this.labelMatricula1 = 'Matrícula Aposentado/Inativo'
    }else if(this.movimentos.situacao_funcional==='4'){
      this.labelMatricula1 = 'Matrícula Pensionista'
    }

    if(this.movimentos.situacao_funcional_2){
      if(this.movimentos.situacao_funcional_2==='1'){
        this.labelMatricula2 = 'Matrícula Ativa'
      }else if(this.movimentos.situacao_funcional_2==='3'){
        this.labelMatricula2 = 'Matrícula Aposentado/Inativo'
      }else if(this.movimentos.situacao_funcional_2==='4'){
        this.labelMatricula2 = 'Matrícula Pensionista'
      }
    }


    this.movimentos.situacao_funcional = '1'

  }

  labelMatricula1 = 'Matrícula'
  labelMatricula2 = 'Matrícula'

  adicionarDependente(){
    const self = this
    if(!self.editandoDependente){
      self.idNovoDependente++
      self.dependente.id=self.idNovoDependente
      self.todosDependentes = [ ...self.todosDependentes, self.dependente];
    }else{
      for(let dep of self.todosDependentes){
        if(dep.id==self.dependente.id){
          dep = self.dependente
        }
      }
    }
    self.editandoDependente = false
    self.adicionandoDependente = false
    self.resetDependente()
  }

  adicionarTempo(){
    const self = this
    if(!self.editandoTempo){
      self.idNovoTempo++
      self.tempopassado.id=self.idNovoTempo
      self.todosTemposPassados = [ ...self.todosTemposPassados, self.tempopassado];
    }else{
      for(let dep of self.todosTemposPassados){
        if(dep.id==self.tempopassado.id){
          dep = self.tempopassado
        }
      }
    }
    self.editandoTempo = false
    self.adicionandoTempo = false
    self.resetTempo()
  }

  liberaDependente(){
    const self = this
    self.adicionandoDependente = true
  }

  liberaTempo(){
    const self = this
    self.adicionandoTempo = true
  }
  cancelaTempo(){
    const self = this
    self.adicionandoTempo = false
    self.editandoTempo = false
    self.resetTempo()
  }

  async editarTempo(tempo){
    const self = this
    self.editandoTempo = true
    self.tempopassado = tempo
  }
  calculaTempoBruto(){
    const self = this
    if((self.tempopassado.data_entrada && self.tempopassado.data_entrada.length==8) && (self.tempopassado.data_fim && self.tempopassado.data_fim.length==8)){
      const entrada = moment(self.tempopassado.data_entrada, 'DDMMYYYY')
      const fim = moment(self.tempopassado.data_fim, 'DDMMYYYY')
      const diferenca = fim.diff(entrada, 'days')
      self.tempopassado.tempo_bruto = diferenca.toString()
    }else{
      self.tempopassado.tempo_bruto = null
    }
  }

  checkValidDate(date){
    if(date){
      const data = moment(date, 'DDMMYYYY')
      return data.isValid()
    }else{
      return false
    }
  }


  checkListDocuments(){
    let verified = true
    return verified;
    for(let d of this.anexosDocumentos){
      if(d.status!==2 && d.status!==5) verified = false
    }
    return verified
  }

  async editarDependente(dep){
    const self = this
    self.editandoDependente = true
    self.dependente = dep
    if(self.dependente.estado){
      const cidades = await self.servidorService.getCidadesPorEstado(self.dependente.estado)
      if(cidades) self.cidadesEnderecoDependente = cidades;
      self.dependente.cidade = dep.cidade
    }
    if(self.dependente.estadoNaturalidade){
      const cidadesn = await self.servidorService.getCidadesPorEstado(self.dependente.estadoNaturalidade)
      if(cidadesn) self.cidadesNaturalidadeDependente = cidadesn;
      self.dependente.cidadeNaturalidade = dep.cidadeNaturalidade
    }
  }

  cancelaDependente(){
    const self = this
    self.editandoDependente = false
    self.adicionandoDependente = false
    self.resetDependente()
  }
  verifyNewTempo(){
    const self = this

    let bloqueia = false
    if (
      !self.tempopassado.cnpj_cpf_empregador
      || !self.tempopassado.nome_empregrador
      || !self.tempopassado.data_entrada
      || !self.tempopassado.data_fim
      || !self.tempopassado.tempo_bruto || !moment(self.tempopassado.data_entrada, 'DDMMYYYY').isSameOrBefore(moment(self.tempopassado.data_fim, 'DDMMYYYY'))
      || (self.servidor.dataIngresso &&  !moment(self.tempopassado.data_entrada, 'DDMMYYYY').isSameOrBefore(moment(self.servidor.dataIngresso, 'DDMMYYYY')))
      || (self.servidor.dataIngresso &&  !moment(self.tempopassado.data_fim, 'DDMMYYYY').isSameOrBefore(moment(self.servidor.dataIngresso, 'DDMMYYYY')))
    ) {
      bloqueia = true;
    }
    return bloqueia
  }

  verifyNewDependente(){
    const self = this

    let bloqueia = false
    if (
      !self.dependente.nome
      || !self.checkValidDate(self.dependente.nascimento)
      || !self.dependente.estadoCivil
      || !self.dependente.sexo
      || !self.dependente.estadoNaturalidade
      || !self.dependente.cidadeNaturalidade
      || !self.dependente.nacionalidade
      || !self.dependente.escolaridade
      || !self.dependente.nomeMae
      || !self.dependente.nomePai
      || !self.dependente.deficiente
      || !self.dependente.tipoLogradouro
      || !self.dependente.logradouro
      || !self.dependente.numero
      || !self.dependente.bairro
      || !self.dependente.estado
      || !self.dependente.cidade
      || !self.dependente.cep
      || !self.dependente.celular
      || !self.dependente.email
      || !self.dependente.tipo_dependencia
      || !self.dependente.motivo_inicio) {
      bloqueia = true;
    }

    return bloqueia
  }
  async postFile(extension, type){
    const response = await this.servidorService.getUrlForUploadS3({extension : extension, type: type})
    if(response.result){
      return response.result
    }else{
      return null
    }
  }

  download(chave, nome){
    saveAs(chave, nome)
  }

  async done() {
    const self = this
    self.loadingAll = true
    var form_data = new FormData();
    let allFiles = []

    for(let a of self.anexosEndereco){
      allFiles.push({url: a.url, extension: a.extension, status: 1, type: a.type, file: a.file})
    }
    for(let a of self.anexosDocumentos){
      allFiles.push({url: a.url, extension: a.extension, status : a.status, type: a.type, file: a.file})
    }
    for(let a of self.anexosDependente){
      allFiles.push({url: a.url, extension: a.extension, status: 1, type: a.type, file: a.file})
    }
    if(this.imgReferencia){
      allFiles.push({url: this.imgReferencia.toString(), extension: 'png', status: -1, type: 'image/png', file: this.dataURItoBlob(this.imgReferencia)})
    }



    const dadosUsuario = self.authenticationService.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    const idUsuario = json.user.id;

    const servidor = await self.servidorService.uploadServidor(idUsuario, self.servidor, self.endereco, self.documento, self.todosDependentes, self.todosTemposPassados, self.movimentos, self.contatos, self.radioVerticalValue)
    if(servidor && servidor.success){
      for(let f of allFiles){
        const url = await this.postFile(f.extension, f.type)
        if(url){
          try{
            var optionsFile = { headers: { 'Content-Type': f.type, 'x-amz-acl': 'public-read' } };
            const uploadFile = await self.api.http.put(url, f.file, optionsFile).toPromise()
          }
          catch(error) {
            console.log(error)
          }
         

          f.file = null
            f.location =  url.toString().split('?',1)[0]
            f.name = f.location.replace('https://cadastro-pessoas-arquivos-servidor.s3.amazonaws.com/', '')
        }
      f.url = null
      }
      await self.servidorService.uploadArquivosServidor(servidor.success, allFiles)
      this.deletePartial()

        self.app.alert(`Sucesso`, `Seus dados foram salvos e vão ser conferidos pela nossa equipe!`, `success`).then(() => {
          self.loadingAll = false;
          setTimeout(() => { 
            this.router.navigate(['/calendly', servidor.success]); 
          }, 500);
        });
    }else{
      self.app.alert(`Erro`, `Erro ao cadastrar seus dados :/`, `error`);
      self.loadingAll = false
    }

   
  }

  isNotPDF(anexo: any): boolean {
    const fileExtension = anexo.extension.split('.').pop().toLowerCase();
    var result =  fileExtension !== 'pdf';
    return result;
  }
  
//   async editarServidor() {
//     const self = this;

//     if (!self.servidor || !self.servidor.id) {
//         return;
//     }

//     // Verificação adicional para status falecido e data de falecimento nula
//     if (self.servidor.status === 5 && !self.servidor.data_falecimento) {
//         await this.app.alert('Erro', 'Data de falecimento deve ser preenchida para servidores falecidos.', 'error');
//         return;
//     }

//     self.spinner.show(undefined, {
//         type: 'ball-triangle-path',
//         size: 'medium',
//         bdColor: 'rgba(0, 0, 0, 0.8)',
//         color: '#fff',
//         fullScreen: true
//     });

//     if (!self.servidor.imagem) self.servidor.imagem = '';
//     if (!self.servidor.pendencias || self.servidor.pendencias == 'null') self.servidor.pendencias = '';
//     if (!self.servidor.observacoes || self.servidor.observacoes == 'null') self.servidor.observacoes = '';
    
//     this.servidor.data_nascimento = this.preparaData(this.servidor.data_nascimento);
//     this.servidor.data_falecimento = this.preparaData(this.servidor.data_falecimento);
//     let data_ingresso_servico_publico = moment(this.servidor.data_ingresso_servico_publico, 'DDMMYYYY').toISOString();
//     this.servidor.concessao_aposentadoria = this.preparaData(this.servidor.concessao_aposentadoria);

//     if (this.servidor.valor_aposentadoria) this.servidor.valor_aposentadoria = this.servidor.valor_aposentadoria.toString().replace('.', '').replace(',', '.');
//     if (this.servidor.valor_beneficio) this.servidor.valor_beneficio = this.servidor.valor_beneficio.toString().replace('.', '').replace(',', '.');
    
//     this.servidor.data_falecimento_pensao = this.preparaData(this.servidor.data_falecimento_pensao);
//     this.servidor.data_nascimento_pensao = this.preparaData(this.servidor.data_nascimento_pensao);
//     this.servidor.agenda = this.statusAgenda.find(item => item.id === this.servidor.agenda)?.descricao;

//     await this.apiCall.get(`servidor/editar?id=${self.servidor.id}&nome=${this.validateQuotes(self.servidor.nome)}&estado_civil=${self.servidor.estado_civil}&pendencias=${self.servidor.pendencias}&observacoes=${self.servidor.observacoes}&motivo_exoneracao=${self.servidor.motivo_exoneracao}&status=${self.servidor.status}&data_nascimento=${self.servidor.data_nascimento}&data_falecimento=${self.servidor.data_falecimento}&nacionalidade=${self.servidor.nacionalidade}&estado_naturalidade=${self.servidor.estado_naturalidade}&cidade_naturalidade=${self.servidor.cidade_naturalidade}&naturalizado=${self.servidor.naturalizado}&escolaridade=${self.servidor.escolaridade}&sexo=${self.servidor.sexo}&nome_mae=${this.validateQuotes(self.servidor.nome_mae)}&nome_pai=${this.validateQuotes(self.servidor.nome_pai)}&data_ingresso_servico_publico=${data_ingresso_servico_publico}&deficiente=${self.servidor.deficiente}&imagem=${self.servidor.imagem}&documento_ingresso_servico_publico=${self.servidor.documento_ingresso_servico_publico}&paridade_aposentadoria=${self.servidor.paridade_aposentadoria}&concessao_aposentadoria=${self.servidor.concessao_aposentadoria}&valor_aposentadoria=${self.servidor.valor_aposentadoria}&cargo_aposentadoria=${self.servidor.cargo_aposentadoria}&pis_aposentado=${self.servidor.pis_aposentado}&tipo_aposentadoria=${self.servidor.tipo_aposentadoria}&cpf_pensao=${self.servidor.cpf_pensao}&pis_pensao=${self.servidor.pis_pensao}&nome_pensao=${self.servidor.nome_pensao}&matricula_pensao=${self.servidor.matricula_pensao}&data_nascimento_pensao=${self.servidor.data_nascimento_pensao}&data_falecimento_pensao=${self.servidor.data_falecimento_pensao}&matricula_beneficiario=${self.servidor.matricula_beneficiario}&tipo_pensao=${self.servidor.tipo_pensao}&valor_beneficio=${self.servidor.valor_beneficio}&tipo_fundo=${self.servidor.tipo_fundo}&tipo_vinculo=${self.servidor.tipo_vinculo}&relacao_titular_pensao=${self.servidor.relacao_titular_pensao}&orgao=${self.servidor.orgao}&agenda=${self.servidor.agenda}&oldStatus=${self.oldStatus}`).pipe(take(1)).toPromise();
    
//     self.spinner.hide();
//     await this.app.alert('Tudo certo!', 'Servidor atualizado com sucesso!', 'success');
//     await self.ngOnInit();
// }
//   async editarServidor() {
//     const self = this;

//     if (!self.servidor || !self.servidor.id) {
//         return;
//     }

//     // Verificação adicional para status falecido e data de falecimento nula
//     if (self.servidor.status === 5 && !self.servidor.data_falecimento) {
//         await this.app.alert('Erro', 'Data de falecimento deve ser preenchida para servidores falecidos.', 'error');
//         return;
//     }

//     self.spinner.show(undefined, {
//         type: 'ball-triangle-path',
//         size: 'medium',
//         bdColor: 'rgba(0, 0, 0, 0.8)',
//         color: '#fff',
//         fullScreen: true
//     });

//     if (!self.servidor.imagem) self.servidor.imagem = '';
//     if (!self.servidor.pendencias || self.servidor.pendencias == 'null') self.servidor.pendencias = '';
//     if (!self.servidor.observacoes || self.servidor.observacoes == 'null') self.servidor.observacoes = '';
    
//     this.servidor.data_nascimento = this.preparaData(this.servidor.data_nascimento);
//     this.servidor.data_falecimento = this.preparaData(this.servidor.data_falecimento);
//     let data_ingresso_servico_publico = moment(this.servidor.data_ingresso_servico_publico, 'DDMMYYYY').toISOString();
//     this.servidor.concessao_aposentadoria = this.preparaData(this.servidor.concessao_aposentadoria);

//     if (this.servidor.valor_aposentadoria) this.servidor.valor_aposentadoria = this.servidor.valor_aposentadoria.toString().replace('.', '').replace(',', '.');
//     if (this.servidor.valor_beneficio) this.servidor.valor_beneficio = this.servidor.valor_beneficio.toString().replace('.', '').replace(',', '.');
    
//     this.servidor.data_falecimento_pensao = this.preparaData(this.servidor.data_falecimento_pensao);
//     this.servidor.data_nascimento_pensao = this.preparaData(this.servidor.data_nascimento_pensao);
//     this.servidor.agenda = this.statusAgenda.find(item => item.id === this.servidor.agenda)?.descricao;

//     await this.apiCall.get(`servidor/editar?id=${self.servidor.id}&nome=${this.validateQuotes(self.servidor.nome)}&estado_civil=${self.servidor.estado_civil}&pendencias=${self.servidor.pendencias}&observacoes=${self.servidor.observacoes}&motivo_exoneracao=${self.servidor.motivo_exoneracao}&status=${self.servidor.status}&data_nascimento=${self.servidor.data_nascimento}&data_falecimento=${self.servidor.data_falecimento}&nacionalidade=${self.servidor.nacionalidade}&estado_naturalidade=${self.servidor.estado_naturalidade}&cidade_naturalidade=${self.servidor.cidade_naturalidade}&naturalizado=${self.servidor.naturalizado}&escolaridade=${self.servidor.escolaridade}&sexo=${self.servidor.sexo}&nome_mae=${this.validateQuotes(self.servidor.nome_mae)}&nome_pai=${this.validateQuotes(self.servidor.nome_pai)}&data_ingresso_servico_publico=${data_ingresso_servico_publico}&deficiente=${self.servidor.deficiente}&imagem=${self.servidor.imagem}&documento_ingresso_servico_publico=${self.servidor.documento_ingresso_servico_publico}&paridade_aposentadoria=${self.servidor.paridade_aposentadoria}&concessao_aposentadoria=${self.servidor.concessao_aposentadoria}&valor_aposentadoria=${self.servidor.valor_aposentadoria}&cargo_aposentadoria=${self.servidor.cargo_aposentadoria}&pis_aposentado=${self.servidor.pis_aposentado}&tipo_aposentadoria=${self.servidor.tipo_aposentadoria}&cpf_pensao=${self.servidor.cpf_pensao}&pis_pensao=${self.servidor.pis_pensao}&nome_pensao=${self.servidor.nome_pensao}&matricula_pensao=${self.servidor.matricula_pensao}&data_nascimento_pensao=${self.servidor.data_nascimento_pensao}&data_falecimento_pensao=${self.servidor.data_falecimento_pensao}&matricula_beneficiario=${self.servidor.matricula_beneficiario}&tipo_pensao=${self.servidor.tipo_pensao}&valor_beneficio=${self.servidor.valor_beneficio}&tipo_fundo=${self.servidor.tipo_fundo}&tipo_vinculo=${self.servidor.tipo_vinculo}&relacao_titular_pensao=${self.servidor.relacao_titular_pensao}&orgao=${self.servidor.orgao}&agenda=${self.servidor.agenda}&oldStatus=${self.oldStatus}`).pipe(take(1)).toPromise();
    
//     self.spinner.hide();
//     await this.app.alert('Tudo certo!', 'Servidor atualizado com sucesso!', 'success');
//     await self.ngOnInit();
// }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private app: App,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private modalService: NzModalService,
    private servidorService: ServidorService,
    private authenticationService: AuthenticationService,
    private api: Api
  ) {
  }
  tplModal: NzModalRef;
  tplModalButtonLoading = false;
  loadingFacialMobile = false;

  countError = 0
  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {

    this.tplModalButtonLoading = true
    // @ts-ignore
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: false,
      nzClosable: false,
      nzOnOk: () => console.log('Click ok')
    });
    this.tplModal.afterOpen.subscribe(() => this.startCamera());
  }

  startCamera() {
    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
      navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);

    } else {
      alert('Sorry, camera not available.');
    }
  }
  video: any;
  attachVideo(stream) {
    this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
    this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
      this.tplModalButtonLoading = false

      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
    });
    this.renderer.listen(this.videoElement.nativeElement, 'pause', (event) => {
      stream.getTracks().forEach(function(track) {
        if (track.readyState == 'live') {
          track.stop();
        }
      });
    });

  }

  updateStatus(value: string) {
    const self = this
    if (value === 'A') {
      this.servidor.status = 1; // Ativo
    } else if (value === 'D') {
      this.servidor.status = 2; // Pensionista
    } else if (value === 'E') {
      this.servidor.status = 3; // Aposentado
    } else if (value === 'F') {
      this.servidor.status = 4; // Exonerado
    }

    if(self.servidor.status && self.servidor.status==1){
      self.carreiras = [...self.carreirasAtivo]
    } else if(self.servidor.status && self.servidor.status==2){
      self.carreiras = [...self.carreirasAposentado]
    } else if(self.servidor.status && self.servidor.status==3){
      self.carreiras = [...self.carreirasPensionista]
    } else if(self.servidor.status && self.servidor.status==4){
      self.carreiras = [...self.carreirasExonerado]
    }
  }

  erroDocumentoRecusado = false
  erroDocumentoNaoIdentificado = false
  imgReferencia = null
  lastResult = null
  lastInput = null
  nextEnabled = false
  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
  }
  capture() {
    try{
      let aux = null
      if(this.videoElement){
        aux = this.videoElement.nativeElement
        this.videoElement.nativeElement.pause()
      }
      this.tplModalButtonLoading = true;
      this.drawCanvas = true
      window.setTimeout(async () => {
        let minConfidence = 0.5
        let results = null
        await faceapi.nets.faceRecognitionNet.loadFromUri('assets/models');
        await faceapi.nets.ssdMobilenetv1.loadFromUri('assets/models');
        await faceapi.nets.faceLandmark68Net.loadFromUri('assets/models');
        let input = null
        if(!(this.nextEnabled && this.lastResult)) {
          this.renderer.setProperty(this.canvas.nativeElement, 'width', this.videoWidth);
          this.renderer.setProperty(this.canvas.nativeElement, 'height', this.videoHeight);
          this.canvas.nativeElement.getContext('2d').drawImage(aux, 0, 0);
          input = document.getElementById('canvas')
          this.lastInput = input
          this.imgReferencia = this.canvas.nativeElement.toDataURL()
          let error = false
          results = await faceapi
            .detectAllFaces(input, new faceapi.SsdMobilenetv1Options())
            .withFaceLandmarks()
            .withFaceDescriptors()
        }else{
          results = this.lastResult
          input = this.lastInput
        }

        this.nextEnabled = false
        if(results && results.length>0){
          this.lastResult = results
            const faceMatcher = new faceapi.FaceMatcher(results)
            this.erroDocumentoNaoIdentificado = false
            this.erroDocumentoRecusado = false
            for(let d of this.anexosDocumentos){
              if(d.status !== 2){
                let img = await faceapi.fetchImage(d.result);
                const singleResult = await faceapi
                  .detectSingleFace(img)
                  .withFaceLandmarks()
                  .withFaceDescriptor()
                if (singleResult) {
                  const bestMatch = faceMatcher.findBestMatch(singleResult.descriptor)
                  if(!bestMatch._label.toString().includes('unknown')){
                    d.status = 2
                  }else{
                    await faceapi.nets.tinyFaceDetector.loadFromUri('assets/models');
                    const secondSingleResult = await faceapi
                      .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions())
                      .withFaceLandmarks()
                      .withFaceDescriptor()
                    if(secondSingleResult){
                      const bestSecontMatch = faceMatcher.findBestMatch(secondSingleResult.descriptor)
                      if(!bestSecontMatch._label.toString().includes('unknown')){
                        d.status = 2
                      }else {
                        const secondResults = await faceapi
                          .detectAllFaces(input, new faceapi.TinyFaceDetectorOptions())
                          .withFaceLandmarks()
                          .withFaceDescriptors()
                        const secondFaceMatcher = new faceapi.FaceMatcher(secondResults)
                        const bestThirdMatch = secondFaceMatcher.findBestMatch(secondSingleResult.descriptor)
                        if(!bestThirdMatch._label.toString().includes('unknown')){
                          d.status = 2
                        }else{
                          d.status = 3
                        }
                      }
                    }else{
                      d.status = 3
                    }
                  }
                }else{
                  await faceapi.nets.tinyFaceDetector.loadFromUri('assets/models');
                  const secondSingleResult = await faceapi
                    .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions())
                    .withFaceLandmarks()
                    .withFaceDescriptor()
                  if(secondSingleResult){
                    const bestSecontMatch = faceMatcher.findBestMatch(secondSingleResult.descriptor)
                    if(!bestSecontMatch._label.toString().includes('unknown')){
                      d.status = 2
                    }else{
                      const secondResults = await faceapi
                        .detectAllFaces(input, new faceapi.TinyFaceDetectorOptions())
                        .withFaceLandmarks()
                        .withFaceDescriptors()
                      const secondFaceMatcher = new faceapi.FaceMatcher(secondResults)
                      const bestThirdMatch = secondFaceMatcher.findBestMatch(secondSingleResult.descriptor)
                      if(!bestThirdMatch._label.toString().includes('unknown')){
                        d.status = 2
                      }else{
                        d.status = 3
                      }
                    }
                  }else{
                    d.status = 4
                  }
                }
              }
            }
          this.erroDocumentoNaoIdentificado = false
          this.erroDocumentoRecusado = false
          //aqui marcar variavel como true
          this.nextEnabled = true
        }else{
          this.app.alert(`Ops :(`, `Você precisa capturar uma foto com seu rosto. Certifique-se de aparecer seu rosto completamente numa boa luminosidade!`, `error`)
        }
        for(let d of this.anexosDocumentos) {
          // 1 = pendente
          // 2 = aprovado
          // 3 = recusado
          // 4 = rosto não identificado
        }

        this.tplModalButtonLoading = false;
        this.tplModal.destroy();
        this.drawCanvas = false
        //caso true avança
        if(this.nextEnabled){
          this.next()
        }
      }, 100);
    }catch(e){
      console.log(e)
      this.app.alert(`Ops :(`, `Ocorreu um erro ao verificar seus documentos, por favor tente verificar novamente!`, `error`)
    }

  }
  handleError(error) {
    console.log('Error: ', error);
  }

  async ngOnInit() {
    const self = this

    self.loadingAll = true
    await faceapi.nets.faceRecognitionNet.loadFromUri('assets/models');
    await faceapi.nets.tinyFaceDetector.loadFromUri('assets/models');
    await faceapi.nets.ssdMobilenetv1.loadFromUri('assets/models');
    await faceapi.nets.faceLandmark68Net.loadFromUri('assets/models');

    const currentUser = self.authenticationService.currentUserValue;
    const json = JSON.parse(JSON.stringify(currentUser))
    const estados = await self.servidorService.getEstados()
    if(estados){
      self.estadosNaturalidade = estados;
    }

    const orgaos = await self.servidorService.getOrgaosExpedidores()
    if(orgaos){
      self.orgaos = orgaos;
    }

    const tiposLogradouro = await self.servidorService.getTiposLogradouro()
    if(tiposLogradouro){
      self.tiposLogradouro = tiposLogradouro;
    }

    const tiposDependencia = await self.servidorService.getTipoDependencia()
    if(tiposDependencia){
      self.tiposDepedencia = tiposDependencia;
    }

    const motivosInicio = await self.servidorService.getMotivosInicioDependencia()
    if(motivosInicio){
      self.motivosInicioDependencia = motivosInicio;
    }

    if(json && json.user && json.user.cidade){
      const orgaosCidade = await self.servidorService.getOrgaosAtivosPorCidade(json.user.cidade)
      if(orgaosCidade) self.orgaosMovimentos = orgaosCidade
    }

    const escolaridades = await self.servidorService.getEscolaridade()
    if(escolaridades){
      self.escolaridades = escolaridades;
    }
    const estadosCivis = await self.servidorService.getEstadoCivil()
    if(estadosCivis){
      self.estadosCivis = estadosCivis;
    }

    const idUsuario = json.user.id;

    await self.verificaCadastroExistente(idUsuario)

    this.verifyTitle()
    self.loadingAll = false

  }

  ngAfterViewInit() {
  }

  async verificaCadastroExistente(idUsuario){
    const self = this
    const servidorCadastrado = await self.servidorService.getServidorCadastrado(idUsuario)
    if(servidorCadastrado && servidorCadastrado.servidor) {
      await self.trataDadosServidorCadastrado(servidorCadastrado)
    } else{
      this.loadPartial()
    }
  }

  

  formatDate(date){
    if(date){
      return moment(date).format('DDMMYYYY')
    }else{
      return ''
    }
  }

  async deleteServidor(){
    const self = this
    console.log('self.idCadastro', self.idCadastro)
    console.log('self.isCadastrado', self.isCadastrado)

    if(self.isCadastrado && self.idCadastro){
      console.log('self.idCadastro', self.idCadastro)
      await self.servidorService.deleteServidor(self.idCadastro)
      window.location.reload();
    }
  }

  async trataDadosServidorCadastrado(data){
    const self = this
    if(data.servidor){
      self.isCadastrado = true
      self.idCadastro = data.servidor.id
      self.swicthStepCurrent=20
      if(data.servidor.estado_naturalidade) await self.searchCidadesNaturalidade(data.servidor.estado_naturalidade)
      self.servidor = {
        id: data.servidor.id,
        nome: data.servidor.nome,
        nascimento: self.formatDate(data.servidor.data_nascimento),
        estadoCivil: data.servidor.estado_civil,
        sexo: data.servidor.sexo,
        status: data.servidor.status,
        estadoNaturalidade: data.servidor.estado_naturalidade,
        cidadeNaturalidade: +data.servidor.cidade_naturalidade,
        nacionalidade: data.servidor.nacionalidade,
        escolaridade: data.servidor.escolaridade,
        nomeMae: data.servidor.nome_mae,
        nomePai: data.servidor.nome_pai,
        dataIngresso: self.formatDate(data.servidor.data_ingresso_servico_publico),
        deficiente: data.servidor.deficiente.toString(),
        agenda: data.servidor.agenda.toString(),
      }
      // if(data.bancario){
      //   self.bancario = {
      //     banco: data.bancario.banco,
      //     tipoConta: data.bancario.tipo_conta,
      //     agencia: data.bancario.agencia,
      //     conta: data.bancario.conta,
      //     digitoConta: data.bancario.digito_conta,
      //   }
      // }
      if(data.endereco){
        if(data.endereco.estado) await self.searchCidadesEndereco(data.endereco.estado)
        self.endereco = {
          tipoLogradouro: data.endereco.tipo_logradouro,
          logradouro: data.endereco.logradouro,
          numero: data.endereco.numero,
          complemento: data.endereco.complemento,
          bairro: data.endereco.bairro,
          estado: data.endereco.estado,
          cidade: +data.endereco.cidade,
          cep: data.endereco.cep,
        }
      }
      if(data.documentos){
        self.documento = {
          cpf: data.documentos.cpf,
          rg: data.documentos.rg,
          dataEmissaoRg: data.documentos.data_emissao_rg,
          orgaoExpedidorRg: data.documentos.orgao_expedidor_rg,
          ufRg: data.documentos.uf_rg,
          nit: data.documentos.nit,
        }
      }
      if(data.contatos){
        self.contatos = {
          telefone: data.contatos.telefone,
          celular: data.contatos.celular,
          email: data.contatos.email,
        }
      }
      if(data.movimentos){
        self.movimentos = {
          tipo_vinculo: data.movimentos.tipo_vinculo,
          matricula: data.movimentos.matricula,
          matricula_2: data.movimentos.matricula_2,
          data_nomeacao: data.movimentos.data_nomeacao,
          data_exercicio: data.movimentos.data_exercicio,
          data_posse: data.movimentos.data_posse,
          cargo_acumulacao: data.movimentos.cargo_acumulacao,
          data_movimentacao: data.movimentos.data_movimentacao,
          situacao_funcional: data.movimentos.situacao_funcional,
          situacao_funcional_2: data.movimentos.situacao_funcional_2,
          orgao: +data.movimentos.orgao,
          carreira: data.movimentos.carreira,
          ingresso_carreira: data.movimentos.ingresso_carreira,
          cargo: data.movimentos.cargo,
          ingresso_cargo: data.movimentos.ingresso_cargo,
          carga_horaria: data.movimentos.carga_horaria,
          local_trabalho: data.movimentos.local_trabalho,
          abono_permanencia: data.movimentos.abono_permanencia.toString(),
          observacoes: data.movimentos.observacoes,
        }
        self.verificaLabelsServidorCadastrado()
      }
      if(data.dependentes){
        for(let dependente of data.dependentes){
          let dependenteParsed = {
            id: dependente.id,
            nome: dependente.nome,
            nascimento: self.formatDate(dependente.data_nascimento),
            estadoCivil: dependente.estado_civil,
            sexo: dependente.sexo,
            estadoNaturalidade: dependente.estado_naturalidade,
            cidadeNaturalidade: +dependente.cidade_naturalidade,
            nacionalidade: dependente.nacionalidade,
            escolaridade: dependente.escolaridade,
            nomeMae: dependente.nome_mae,
            nomePai: dependente.nome_pai,
            deficiente: dependente.deficiente.toString(),
            tipoLogradouro: dependente.tipo_logradouro,
            logradouro: dependente.logradouro,
            numero: dependente.numero,
            complemento: dependente.complemento,
            bairro: dependente.bairro,
            estado: dependente.estado,
            cidade: +dependente.cidade,
            cep: dependente.cep,
            telefone: dependente.telefone,
            celular: dependente.celular,
            email: dependente.email,
            tipo_dependencia: dependente.tipo_dependencia,
            motivo_inicio: dependente.motivo_inicio,
          }
          self.todosDependentes = [ ...self.todosDependentes, dependenteParsed];
        }
      }
      if(data.tempos) {
        for(let tempos of data.tempos) {
          let tempopassado = {
            id: tempos.id,
            cnpj_cpf_empregador: tempos.cnpj_cpf_empregador,
            nome_empregrador: tempos.nome_empregrador,
            data_entrada: self.formatDate(tempos.data_entrada),
            data_fim: self.formatDate(tempos.data_fim),
            tempo_bruto: tempos.tempo_bruto,
          }
          self.todosTemposPassados = [ ...self.todosTemposPassados, tempopassado];
        }
      }
      if(data.arquivos) {
        for(let arquivo of data.arquivos) {
          let file = {
            id: arquivo.id,
            nome: arquivo.nome,
            chave: arquivo.chave
          }
          self.anexos = [ ...self.anexos, file];

        }
      }
    }else{
      self.isCadastrado = false
      self.swicthStepCurrent=0

    }
  }



  async searchCidadesNaturalidade($event){
    const self = this
    self.servidor.cidadeNaturalidade = null
    if($event){
      self.loadingCidades = true
      const cidades = await self.servidorService.getCidadesPorEstado($event)
      if(cidades){
        self.cidadesNaturalidade = cidades;
      }
      self.loadingCidades = false
    }
  }

  async searchCidadesNaturalidadeDependente($event){
    const self = this
    self.dependente.cidadeNaturalidade = null
    if($event){
      self.loadingCidadesDependente = true
      const cidades = await self.servidorService.getCidadesPorEstado($event)
      if(cidades){
        self.cidadesNaturalidadeDependente = cidades;
      }
      self.loadingCidadesDependente = false
    }
  }

  temPendente(){
    return true;
    if(!this.imgReferencia){
      if(this.anexosDocumentos){
        for(let d of this.anexosDocumentos){
          d.status=1
        }
        return this.anexosDocumentos.find(d => d.status==1)

      }else{
        return null
      }
    }else{
      return this.anexosDocumentos.find(d => d.status==1)

    }
  }
  viewPhoto(url){
    this.modalDocument = url;
    this.viewModalDocument = true;
  }
  removeAnexoEndereco(id){
    const self = this
    const foundFile =  self.anexosEndereco.find(a=>a.id ==id)
    if(foundFile){
      let indice = self.anexosEndereco.findIndex(a=>a.id ==id);
      if (indice > -1) {
        self.anexosEndereco.splice(indice, 1);
      }
    }
  }
  removeAnexoDocumento(id){
    const self = this
    const foundFile =  self.anexosDocumentos.find(a=>a.id ==id)
    if(foundFile){
      let indice = self.anexosDocumentos.findIndex(a=>a.id ==id);
      if (indice > -1) {
        self.anexosDocumentos.splice(indice, 1);
      }
    }
  }
  removeAnexoDependente(id){
    const self = this
    const foundFile =  self.anexosDependente.find(a=>a.id ==id)
    if(foundFile){
      let indice = self.anexosDependente.findIndex(a=>a.id ==id);
      if (indice > -1) {
        self.anexosDependente.splice(indice, 1);
      }
    }
  }
  idAnexoEndereco = 0
  idAnexoDocumentos = 0
  idAnexoBancario = 0
  idAnexoDependente = 0

  fileTypes = ['jpg', 'jpeg', 'png', 'pdf'];  //acceptable file types

  handleUpload(event) {
    const self = this;
    const file = event.target.files[0];
    let extension = file.name.split('.').pop().toLowerCase(),  //file extension from input file
      isSuccess = self.fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
    if (isSuccess) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        self.idAnexoEndereco++
        //console.log(reader.result)
        self.anexosEndereco.push({id: self.idAnexoEndereco, url: reader.result.toString(), extension: extension, type: file.type,
          file: file});
        self.anexoEndereco = null

      };
      reader.onabort = () => {
        self.anexoEndereco = null

      };
      reader.onerror = () => {
        self.anexoEndereco = null

      };
    }else{
      self.anexoEndereco = null

    }
  }

  async beforeCaptureMobile(fileUpload){
    const self = this;
    self.app.alert(`Atenção!`,
      `Agora você precisa capturar uma foto/selfie sua verificarmos seus documentos posteriormente. Certifique-se de capturar uma foto onde o seu rosto estejam bem visível, com boa nitidez e luminosidade. Não utilize bonés, óculos e nem sorria!`
      , `warning`).then(async (result) => {
      return fileUpload.click()
    });
  }


  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  async handleUploadDocumentos(event) {
    const self = this;
    const file = event.target.files[0];
    let extension = file.name.split('.').pop().toLowerCase(),  // file extension from input file
      isSuccess = self.fileTypes.indexOf(extension) > -1;  // is extension in acceptable types
    
    if (isSuccess) {
      const reader = new FileReader();
  
      reader.readAsDataURL(file);
      reader.onload = async () => {
        let result;
      
          result = reader.result;
        
  
        if (self.anexosDocumentos[0]) {
          // Processamento adicional para imagens
        }
  
        self.idAnexoDocumentos++;
  
        self.anexosDocumentos.push({
          id: self.idAnexoDocumentos,
          result: result,
          url: result.toString(),
          extension: extension,
          status: 1,
          type: file.type,
          file: file
        });
  
        self.anexoDocumentos = null;
      };
  
      reader.onabort = () => {
        self.anexoDocumentos = null;
      };
  
      reader.onerror = () => {
        self.anexoDocumentos = null;
      };
    } else {
      self.anexoDocumentos = null;
    }
  }
  handleUploadDependente(event) {
    const self = this;
    const file = event.target.files[0];
    let extension = file.name.split('.').pop().toLowerCase(),  //file extension from input file
      isSuccess = self.fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
    if (isSuccess) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        self.idAnexoDependente++
        self.anexosDependente.push({id: self.idAnexoDependente, url: reader.result.toString(), extension: extension, type: file.type,
          file: file});
        self.anexoDependentes = null
      };
      reader.onabort = () => {
        self.anexoDependentes = null

      };
      reader.onerror = () => {
        self.anexoDependentes = null

      };
    }else{
      self.anexoDependentes = null

    }
  }
  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
  }
  async searchCidadesEndereco($event){
    const self = this
    self.loadingCidadeEndereco = true
    self.endereco.cidade = null
    if($event){
      const cidades = await self.servidorService.getCidadesPorEstado($event)
      if(cidades){
        self.cidadesEndereco = cidades;
      }
      self.loadingCidadeEndereco = false
    }
  }
  async searchCidadesEnderecoDependente($event){
    const self = this
    self.loadingCidadeEnderecoDependente = true
    self.dependente.cidade = null
    if($event){
      const cidades = await self.servidorService.getCidadesPorEstado($event)
      if(cidades){
        self.cidadesEnderecoDependente = cidades;
      }
      self.loadingCidadeEnderecoDependente = false
    }
  }

  consultaCepDependente() {
    const self = this;
    self.searchingCepDependente = true
    cep(self.dependente.cep).then(async local => {
      self.dependente.logradouro = local.street
      let tipoLogradouro = local.street.split(' ')[0]
      if(tipoLogradouro){
        const tipoLogradouroEncontrado = self.tiposLogradouro.find(e=>e.descricao.toString().toLowerCase().includes(tipoLogradouro.toString().toLowerCase()))
        if(tipoLogradouroEncontrado){
          self.dependente.tipoLogradouro = tipoLogradouroEncontrado.id
        }
      }
      self.dependente.bairro = local.neighborhood
      self.dependente.estado = local.state
      await self.searchCidadesEnderecoDependente(local.state)
      const cidadeEncontrada = self.cidadesEnderecoDependente.find(e=>e.nome.toString().toLowerCase().includes(local.city.toString().toLowerCase()))
      if(cidadeEncontrada){
        self.dependente.cidade = cidadeEncontrada.id
      }
      self.searchingCepDependente = false
    }).catch(erro => {
      self.searchingCepDependente = false
    });
  }

  consultaCep() {
    const self = this;
    self.searchingCep = true
    cep(self.endereco.cep).then(async local => {
      self.endereco.logradouro = local.street
      let tipoLogradouro = local.street.split(' ')[0]
      if(tipoLogradouro){
        const tipoLogradouroEncontrado = self.tiposLogradouro.find(e=>e.descricao.toString().toLowerCase().includes(tipoLogradouro.toString().toLowerCase()))
        if(tipoLogradouroEncontrado){
          self.endereco.tipoLogradouro = tipoLogradouroEncontrado.id
        }
      }
      self.endereco.bairro = local.neighborhood
      self.endereco.estado = local.state
      await self.searchCidadesEndereco(local.state)
      const cidadeEncontrada = self.cidadesEndereco.find(e=>e.nome.toString().toLowerCase().includes(local.city.toString().toLowerCase()))
      if(cidadeEncontrada){
        self.endereco.cidade = cidadeEncontrada.id
      }
      self.searchingCep = false
    }).catch(erro => {
      self.searchingCep = false
    });
  }
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  verifyTitle(){
    switch (this.swicthStepCurrent) {
      case 0: {
        this.titleStep = 'Instruções';
        break;
      }
      case 10: {
        this.titleStep = 'Tipo de Cadastro';
        break;
      }
      case 20: {
        this.titleStep = 'Selecione o status';
        break;
      }
      case 30: {
        this.titleStep = 'Informações Básicas';
        break;
      }
      case 40: {
        this.titleStep = 'Documentos';
        break;
      }
      case 50: {
        this.titleStep = 'Endereço';
        break;
      }
      case 60: {
        this.titleStep = 'Contatos';
        break;
      }
      case 70: {
        if(!this.adicionandoDependente){
          this.titleStep = 'Dependentes';
        }else{
          this.titleStep = 'Novo Dependente';
        }
        break;
      }
      case 80: {
        this.titleStep = 'Movimentos Funcionais';
        break;
      }
      case 90: {
        this.titleStep = 'Anexos';
        break;
      }
      case 100: {
        this.isCadastrado ? this.titleStep = 'Ao finalizar o seu cadastro, solicitamos que agende uma chamada de video para a validação dos dados. Obrigado.' : this.titleStep = 'Cadastro Finalizado!'
        break;
      }
      default: {
        this.titleStep = '';
      }
    }
  }

  removerDependente(i){
    this.todosDependentes = this.todosDependentes.filter(d => d.id !== i);
  }

  removerTempo(i){
    this.todosTemposPassados = this.todosTemposPassados.filter(d => d.id !== i);
  }

  async toggleEnderecoEContatos(event){
    const self = this
    if(event){
      self.dependente.tipoLogradouro = self.endereco.tipoLogradouro
      self.dependente.logradouro = self.endereco.logradouro
      self.dependente.numero = self.endereco.numero
      self.dependente.complemento = self.endereco.complemento
      self.dependente.bairro = self.endereco.bairro
      self.dependente.estado = self.endereco.estado
      self.dependente.cep = self.endereco.cep
      self.dependente.telefone = self.contatos.telefone
      self.dependente.celular = self.contatos.celular
      self.dependente.email = self.contatos.email
      if(self.endereco.estado){
        await self.searchCidadesEnderecoDependente(self.endereco.estado)
        self.dependente.cidade = self.endereco.cidade
      }
    }else{
        self.dependente.tipoLogradouro = null
        self.dependente.logradouro = null
        self.dependente.numero = null
        self.dependente.complemento = null
        self.dependente.bairro = null
        self.dependente.estado = null
        self.dependente.cidade = null
        self.dependente.cep = null
        self.dependente.telefone = null
        self.dependente.celular = null
        self.dependente.email = null
        self.cidadesEnderecoDependente = []
    }
  }
  resetDependente(){
    const self = this
    self.dependente = {
      id: null,
      nome: null,
      nascimento: null,
      estadoCivil: null,
      sexo: null,
      estadoNaturalidade: null,
      cidadeNaturalidade: null,
      nacionalidade: 'Brasileiro',
      escolaridade: null,
      nomeMae: null,
      nomePai: null,
      deficiente: null,
      tipoLogradouro: null,
      logradouro: null,
      numero: null,
      complemento: null,
      bairro: null,
      estado: null,
      cidade: null,
      cep: null,
      telefone: null,
      celular: null,
      email: null,
      tipo_dependencia: null,
      motivo_inicio: null,
    }
    self.copiarDoServidor = false
  }
  resetTempo(){
    const self = this
    self.tempopassado = {
      id: null,
      cnpj_cpf_empregador: null,
      nome_empregrador: null,
      data_entrada: null,
      data_fim: null,
      tempo_bruto: null,
    }

  }

  verifyStep(){
    const self = this
    let desabilita =  false
    switch (this.swicthStepCurrent) {
      case 0: {
        break;
      }
      case 10: {
        break;
      }
      case 20: {
        if(!self.radioVerticalValue || self.radioVerticalValue=='') desabilita = true
        break;
      }
      case 30: {
        if(!self.servidor.nome || !self.servidor.nomeMae || !self.servidor.nomePai || !this.checkValidDate(self.servidor.dataIngresso) || !self.servidor.deficiente || !self.servidor.escolaridade || !self.servidor.nacionalidade|| !self.servidor.cidadeNaturalidade || !self.servidor.estadoNaturalidade || !self.servidor.estadoCivil || !self.servidor.sexo || !this.checkValidDate(self.servidor.nascimento)) desabilita = true
        break;
      }
      case 40: {
        if(!self.documento.rg || !self.documento.cpf || !self.documento.ufRg  || !self.documento.nit) desabilita = true
        break;
      }
      case 50: {
        if(!self.endereco.tipoLogradouro || !self.endereco.logradouro || !self.endereco.cep || !self.endereco.numero || !self.endereco.bairro || !self.endereco.cidade || !self.endereco.estado ) desabilita = true
        break;
      }
      case 60: {
        if(!self.contatos.celular || !self.contatos.email || !self.validateEmail(self.contatos.email)) desabilita = true
        break;
      }
      case 70: {
        // if(!self.bancario.banco || !self.bancario.tipoConta || !self.bancario.digitoConta || !self.bancario.conta || !self.bancario.agencia || self.anexosBancario.length==0) desabilita = true
        break;
      }
      case 80: {
        desabilita = false
        break;
      }
      case 90: {
        // if(!self.movimentos.tipo_vinculo || !self.movimentos.matricula || !this.checkValidDate(self.movimentos.data_nomeacao) || !this.checkValidDate(self.movimentos.data_exercicio) || !this.checkValidDate(self.movimentos.data_posse) || !self.movimentos.cargo_acumulacao || !this.checkValidDate(self.movimentos.data_movimentacao) || !self.movimentos.orgao || !self.movimentos.carreira || !this.checkValidDate(self.movimentos.ingresso_carreira)|| (self.radioVerticalValue=='C' && !self.movimentos.matricula_2) ||((self.radioVerticalValue=='A' || self.radioVerticalValue=='C') &&(!self.movimentos.cargo || !this.checkValidDate(self.movimentos.ingresso_cargo) || !self.movimentos.carga_horaria || !self.movimentos.local_trabalho || !self.movimentos.abono_permanencia))) desabilita = true
         break;
      }
      case 100: {
        break;
      }
      default: {

      }
    }
    return desabilita
  }
}
